import DonationList from './DonationList'

export default DonationList
